function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var HudLayer = require('../hud-layer');
var MenuTemplate = require('./menu.template');
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var MenuOverlay = /*#__PURE__*/function () {
  function MenuOverlay(app, mod, c1, c2, c3) {
    _classCallCheck(this, MenuOverlay);
    this.app = app;
    this.mod = mod;
    this.visible = false;
    this.overlay = new SaitoOverlay(app, mod, true, false, false);
  }
  return _createClass(MenuOverlay, [{
    key: "hide",
    value: function hide() {
      this.overlay.hide();
    }
  }, {
    key: "pullHudOverOverlay",
    value: function pullHudOverOverlay() {
      HudLayer.pullHudOverOverlay.call(this);
    }
  }, {
    key: "pushHudUnderOverlay",
    value: function pushHudUnderOverlay() {
      HudLayer.pushHudUnderOverlay.call(this);
    }
  }, {
    key: "render",
    value: function render(menu, player, faction, ops) {
      var _this = this;
      var attachEventsToOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      var his_self = this.mod;
      var menu_style = 'classic'; // classic ==> starting menus, then submenus
      // simple  ==> one-click up to 9 options

      this.overlay.show(MenuTemplate());

      //
      // Foul Weather remove Assault
      //
      if (his_self.game.state.events.foul_weather == 1) {
        for (var i = 0; i < menu.length; i++) {
          if (menu[i].name == 'Assault') {
            menu.splice(i, 1);
            i--;
          }
        }
      }
      this.pushHudUnderOverlay();
      var sub_menu = function sub_menu(main_menu, _sub_menu, options) {
        for (var _i = 0; _i < options.length; _i++) {
          var menu_item = options[_i];
          var idx = menu_item.idx;
          var cost = menu_item.cost;
          var active_option = menu_item.active;
          var costtext = '- ' + cost + ' op';
          if (cost > 1) {
            costtext += 's';
          }
          var html = "\n\t\t\t\t      <div id=\"".concat(idx, "\" class=\"menu-option-container ").concat(active_option, "\">\n\t\t\t\t        <div class=\"menu-option-image\">\n\t\t\t\t          <img src=\"").concat(menu[idx].img, "\" />\n\t\t\t\t        </div>\n\t\t\t\t        <div class=\"menu-option-title\">").concat(menu[idx].name, " ").concat(costtext, "</div>\n\t\t\t\t      </div>\n\t\t\t\t");
          if (cost == 0) {
            html = "\n\t\t\t\t      <div id=\"".concat(idx, "\" class=\"menu-option-container ").concat(active_option, "\">\n\t\t\t\t        <div class=\"menu-option-image\">\n\t\t\t\t          <img src=\"").concat(menu[idx].img, "\" />\n\t\t\t\t        </div>\n\t\t\t\t        <div class=\"menu-option-title\">").concat(menu[idx].name, "</div>\n\t\t\t\t      </div>\n\t\t\t\t  ");
          }
          _this.app.browser.addElementToSelector(html, ".movemenu");
        }
        document.querySelector('.movemenu').classList.add("m".concat(options.length, "entries"));
        if (attachEventsToOptions != null) {
          attachEventsToOptions();
        }
      };
      var main_menu = function main_menu(_main_menu) {
        //
        // arrange options into categories
        //
        var move = [];
        var build = [];
        var special = [];
        var and_attack = '';

        //
        // revert to simple menu
        //
        var active_menu_options = 0;
        for (var _i2 = 0; _i2 < menu.length; _i2++) {
          var _id = '';
          var cost = 100;
          if (menu[_i2].check(_this.mod, player, faction, ops)) {
            for (var z = 0; z < menu[_i2].factions.length; z++) {
              if (menu[_i2].factions[z] === faction) {
                _id = _i2;
                cost = menu[_i2].cost[z];
                z = menu[_i2].factions.length + 1;
              }
            }
          }
          var active_option = 'inactive';
          if (cost <= ops) {
            active_option = 'active card';
          }
          if (!menu[_i2].check(_this.mod, _this.mod.game.player, faction, ops)) {
            active_option = 'inactive';
          }
          if (cost != 100 && active_option != 'inactive') {
            active_menu_options++;
            if (menu[_i2].category == 'build') {
              build.push({
                idx: _i2,
                cost: cost,
                active: active_option
              });
            }
            if (menu[_i2].category == 'move') {
              move.push({
                idx: _i2,
                cost: cost,
                active: active_option
              });
            }
            if (menu[_i2].category == 'attack') {
              and_attack = ' and Attack';
              move.push({
                idx: _i2,
                cost: cost,
                active: active_option
              });
            }
            if (menu[_i2].category != 'move' && menu[_i2].category != 'attack' && menu[_i2].category != 'build') {
              special.push({
                idx: _i2,
                cost: cost,
                active: active_option
              });
            }
          }
        }
        if (active_menu_options <= 20) {
          if (active_menu_options > 9) {
            active_menu_options = 9;
          }
          sub_menu(_main_menu, sub_menu, move);
          sub_menu(_main_menu, sub_menu, build);
          sub_menu(_main_menu, sub_menu, special);
          document.querySelector('.movemenu').classList.add("m".concat(active_menu_options, "entries"));
          return;
        }
        if (menu.length > 3) {
          document.querySelector('.movemenu').classList.add('menu-large');
          var build_html = "\n\t\t\t\t    <div id=\"build\" class=\"menu-option-container-large build-menu\">\n\t\t\t\t      <div class=\"menu-option-title-large\">Build</div>\n\t\t\t\t    </div>\n\t\t\t\t";
          if (build.length > 0) {
            _this.app.browser.addElementToSelector(build_html, ".movemenu");
            var content = '';
            for (var _z = 0; _z < build.length; _z++) {
              if (_z > 0) {
                content += ', ';
              }
              content += menu[build[_z].idx].name.toLowerCase();
            }
            if (content != '') {
              _this.app.browser.addElementToSelector("<div class=\"menu-option-content-large\">".concat(content, "</div>"), ".build-menu");
            }
          }
          var move_html = "\n\t\t\t\t    <div id=\"move\" class=\"menu-option-container-large move-menu\">\n\t\t\t\t      <div class=\"menu-option-title-large\">Move".concat(and_attack, "</div>\n\t\t\t\t    </div>\n\t\t\t\t  ");
          if (move.length > 0) {
            _this.app.browser.addElementToSelector(move_html, ".movemenu");
            var _content = '';
            for (var _z2 = 0; _z2 < move.length; _z2++) {
              if (_z2 > 0) {
                _content += ', ';
              }
              _content += menu[move[_z2].idx].name.toLowerCase();
            }
            if (_content != '') {
              _this.app.browser.addElementToSelector("<div class=\"menu-option-content-large\">".concat(_content, "</div>"), ".move-menu");
            }
          }
          var special_html = "\n\t\t\t\t    <div id=\"special\" class=\"menu-option-container-large special-menu\">\n\t\t\t\t      <div class=\"menu-option-title-large\">Special</div>\n\t\t\t\t    </div>\n\t\t\t\t  ";
          if (special.length > 0) {
            _this.app.browser.addElementToSelector(special_html, ".movemenu");
            var _content2 = '';
            for (var _z3 = 0; _z3 < special.length; _z3++) {
              if (_z3 > 0) {
                _content2 += ', ';
              }
              _content2 += menu[special[_z3].idx].name.toLowerCase();
            }
            if (_content2 != '') {
              _this.app.browser.addElementToSelector("<div class=\"menu-option-content-large\">".concat(_content2, "</div>"), ".special-menu");
            }
          }
          document.querySelectorAll('.menu-option-container-large').forEach(function (obj) {
            obj.onclick = function (e) {};
            obj.onclick = function (e) {
              var id = e.currentTarget.id;
              document.querySelector('.movemenu').classList.remove('menu-large');
              document.querySelector('.movemenu').innerHTML = '';
              if (id == 'build') {
                sub_menu(_main_menu, sub_menu, build);
                return;
              }
              if (id == 'move') {
                sub_menu(_main_menu, sub_menu, move);
                return;
              }
              if (id == 'special') {
                sub_menu(_main_menu, sub_menu, special);
                return;
              }
            };
          });
          _this.attachEvents();
          return;
        }

        //
        // duplicates code below
        //
        for (var _i3 = 0; _i3 < menu.length; _i3++) {
          var _id2 = '';
          var _cost = 100;
          if (menu[_i3].check(_this.mod, player, faction, ops)) {
            for (var _z4 = 0; _z4 < menu[_i3].factions.length; _z4++) {
              if (menu[_i3].factions[_z4] === faction) {
                _id2 = _i3;
                _cost = menu[_i3].cost[_z4];
                _z4 = menu[_i3].factions.length + 1;
              }
            }
          }
          var _active_option = 'inactive';
          if (_cost <= ops) {
            _active_option = 'active card';
          }
          if (!menu[_i3].check(_this.mod, _this.mod.game.player, faction, ops)) {
            _active_option = 'inactive';
          }
          if (_cost != 100) {
            if (_active_option !== 'inactive') {
              _this.app.browser.addElementToSelector(_this.returnMenuHTML(menu[_i3].name, menu[_i3].img, _active_option, menu[_i3].cost), ".movemenu");
            }
          }
        }
        _this.attachEvents();
      };

      //
      // show and render
      //
      main_menu(main_menu);
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {}
  }, {
    key: "returnMenuHTML",
    value: function returnMenuHTML() {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var img = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var active_option = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'active card';
      var cost = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      if (cost == 0) {
        return "\n\t      <div id=\"".concat(id, "\" class=\"menu-option-container ").concat(active_option, "\">\n\t        <div class=\"menu-option-image\">\n\t          <img src=\"").concat(img, "\" />\n\t        </div>\n\t        <div class=\"menu-option-title\">").concat(name, "</div>\n\t      </div>\n\t    ");
      } else {
        var costtext = '- ' + cost + ' op';
        if (cost > 1) {
          costtext += 's';
        }
        return "\n\t      <div id=\"".concat(id, "\" class=\"menu-option-container ").concat(active_option, "\">\n\t        <div class=\"menu-option-image\">\n\t          <img src=\"").concat(img, "\" />\n\t        </div>\n\t        <div class=\"menu-option-title\">").concat(name, " ").concat(costtext, "</div>\n\t      </div>\n\t    ");
      }
    }
  }]);
}();
module.exports = MenuOverlay;